var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4291 9.99981L18.282 3.93021C18.4216 3.7854 18.5 3.58903 18.5 3.38426C18.5 3.17949 18.4216 2.9831 18.282 2.83829L16.4058 0.892711C16.2662 0.747912 16.0768 0.666566 15.8794 0.666566C15.6819 0.666566 15.4925 0.747912 15.3529 0.892711L9.49999 6.96227L3.64711 0.892649C3.50749 0.747852 3.3181 0.666504 3.12064 0.666504C2.92318 0.666504 2.73381 0.747852 2.59419 0.892649L0.71806 2.83823C0.578448 2.98304 0.500017 3.17942 0.500017 3.38419C0.500017 3.58896 0.578448 3.78535 0.71806 3.93015L6.57094 9.99981L0.71806 16.0695C0.578447 16.2143 0.5 16.4107 0.5 16.6155C0.5 16.8202 0.578447 17.0166 0.71806 17.1614L2.59419 19.107C2.73381 19.2518 2.92318 19.3332 3.12064 19.3332C3.3181 19.3332 3.50749 19.2518 3.64711 19.107L9.49999 13.0374L15.3529 19.107C15.4925 19.2518 15.6819 19.3332 15.8794 19.3332C16.0768 19.3332 16.2662 19.2518 16.4058 19.107L18.282 17.1614C18.4216 17.0166 18.5 16.8202 18.5 16.6155C18.5 16.4107 18.4216 16.2143 18.282 16.0695L12.4291 9.99981Z",
    fill: "#9A9A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGrey);
export default __webpack_public_path__ + "static/media/close-grey.4b168e9ca95c2e37f6a2af442269d73f.svg";
export { ForwardRef as ReactComponent };